import React from 'react'
import { Link } from 'react-router-dom'
import { Image } from '../../../AbstractElements'
import { Col } from 'reactstrap'
import { useDispatch } from 'react-redux'
import { useSelector } from 'react-redux'
import { RootState } from '../../../ReduxToolkit/Store'
import { setSideBarToggle } from '../../../ReduxToolkit/Reducers/Layout/LayoutReducer'
import SvgIcon from '../../../Utils/CommonComponents/CommonSvgIcons'
import { Href } from '../../../Utils/Constants'

export default function HorizontalLogo() {
    const dispatch = useDispatch();
    const { sideBarToggle } = useSelector((state: RootState) => state.layout);
    const handleSidebarToggle = () => {
        dispatch(setSideBarToggle(!sideBarToggle));
    };
    return (
        <Col xs="auto" className="logo-wrapper d-flex align-items-center">
            <Link to={`/dashboard/default`}>
                <h3 style={{ color: 'white' }}>Admin Panel</h3>
                {/* <Image className="light-logo img-fluid" width={140} src='/logo1.png' alt="logo" /> */}
                {/* <Image className="light-logo" width={30} height={25} src={dynamicImage(`logo/logo-name.png`)} alt="logo" /> */}
            </Link>
            <a className="close-btn toggle-sidebar" href={Href} onClick={handleSidebarToggle}>
                <SvgIcon className="svg-color" iconId="Category" />
            </a>
        </Col>
    )
}
